/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntroductionInquiryDto } from '../../models/introduction-inquiry-dto';

export interface IntroductionInquiryControllerFindById$Params {
  id: string;
}

export function introductionInquiryControllerFindById(http: HttpClient, rootUrl: string, params: IntroductionInquiryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<IntroductionInquiryDto>> {
  const rb = new RequestBuilder(rootUrl, introductionInquiryControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntroductionInquiryDto>;
    })
  );
}

introductionInquiryControllerFindById.PATH = '/api/introduction-inquiry/{id}';
